import React                    from 'react';
import { connect }              from 'react-redux';
import moment                   from 'moment';
import { Link,Redirect }                 from 'react-router-dom';
import { GetAtividadesLista,
         GetTipoAtividade,
         SetExcluirAtividades,
         SetAnularAtividades } from '../../../actions/atividadesAction';
import { SetError }             from '../../../actions/notificacaoAction';
import FlashRetornoNulo         from '../../../container/FlashRetornoNulo';
import FlashCarregando        from '../../../container/FlashCarregando';


class Desafios_Professor_Lista extends React.Component {


    constructor(props){
        super(props);
       this.state = {load:false}

    }

    componentWillMount(){
        this.props.GetAtividadesLista(this.props.session.id,this.props.session.perfil)
        .then((response) => {;

        this.setState({load:true});       
        }).catch((error) =>{
        this.props.SetError(500);
    });

    }
    renderStatus(elem){
        var obj = {}
        switch(elem.status) {
            case 1:
                obj = {status:'Em andamento',classe:'status status-verde',icone:'glyphicon glyphicon-ok-circle',acao1:1,acao2:0,acao3:0};
            break;
            case 2:
                obj = {status:'Encerrada', classe:'status status-azul',icone:'glyphicon glyphicon-ban-circle',acao1:1,acao2:0,acao3:1};
            break;
            case 3:
            break;
            case 4:
                obj = {status:'Anulada', classe:'status status-vermelho',icone:'glyphicon glyphicon-remove-circle',acao1:1,acao2:1,acao3:1};
            break;
            case 5:
                obj = {status:'Com pendência', classe:'status status-cinza',icone:'glyphicon glyphicon-exclamation-sign',acao1:0,acao2:1,acao3:1};
            break;
            case 6:
                obj = {status:'Não iniciada', classe:'status status-azul',icone:'glyphicon glyphicon-info-sign',acao1:0,acao2:0,acao3:1};
            break;
            default:
            break;
        }
       
        return obj;

    } 

    getStatusButtonAtividades(elem,i){
        
         let retorno = {}
         let status  = this.renderStatus(elem);

         retorno = {                   
                    duplicar : <li><Link to={`${this.props.menu.desafios.duplicar}/${elem.ati_id}`}>Duplicar</Link></li>,
                    exclusao : (status.acao1 === 1 ? "" : <li><a href={void(0)} onClick={this.exclusaoMissao.bind(this,elem.ati_id)}>Excluir Desafio</a></li>),
                    editar   : (status.acao1 === 1 ? "" : <li><Link to={`${this.props.menu.desafios.editar}/${elem.ati_id}`}>Editar</Link></li>),
                    anular   : (status.acao3 === 1 ? "" : <li><a href={void(0)} onClick={this.anularMissao.bind(this,elem.ati_id)}>Anular Desafio</a></li>),
                    Jogo     : (status.acao2 === 1 ? "" : <li><Link to={`${this.props.menu.desafios.jogos}/${elem.ati_id}/${elem.ati_tipo}`}>Testar Desafio</Link></li>)
                   }
               
                     return  <div className="btn-group">
                              <button type="button" className="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="glyphicon glyphicon-option-vertical"></span>
                              </button>
                                <ul className="pull-right dropdown-menu">
                                {retorno.duplicar}
                                {retorno.editar}
                                {retorno.Jogo}                              
                                {retorno.anular}                              
                                {retorno.exclusao}                              
                                </ul>
                        </div>;
   }

    exclusaoMissao(ati_id){
        const acao = window.confirm("Deseja Remover Desafio?");
         if(acao) {
             this.props.SetExcluirAtividades(ati_id,this.props.session.id).then((response)=>{
                window.location.reload();
             });
          }
    }

    anularMissao(ati_id){
        const acao = window.confirm("Deseja Anular Desafio?");
        if (acao) {
        this.props.SetAnularAtividades(ati_id,this.props.session.id).then((response)=>{
            window.location.reload();
        });
        }
    }

    renderUrl(elem){
        let ret     = {}
        switch (elem.ati_tipo) {
            case this.props.menu.desafios.jogo.tipo1:
                ret = {
                    url         : this.props.menu.desafios.editar,
                    questaoMenu : this.props.menu.desafios.desafiosenha
                    };                    
            break;    
        
            case this.props.menu.desafios.jogo.tipo2:
                ret = {
                    url         : this.props.menu.desafios.editar,
                    questaoMenu : this.props.menu.desafios.desafiobomba
                    };   
            break;
        
            case this.props.menu.desafios.jogo.tipo3:
            ret = {
                    url         : this.props.menu.desafios.editar,
                    questaoMenu : this.props.menu.desafios.desafioquiz
                    };
            break;
            default:
            break;
        }
        return ret;
    }

    renderListAtividades(){

        const retornoListaDesafios = this.props.atividadesProfessor.filter(elem => (this.props.checkSelect == null ? elem.status === 1 || elem.status === 5 || elem.status === 6 : elem.status ===2 || elem.status ===3 || elem.status ===4  ));

        if(retornoListaDesafios.length){

            return  retornoListaDesafios.map((elem,i) =>{
               
                const status = this.renderStatus(elem);
                const url = this.renderUrl(elem).questaoMenu;

                return  <div className="panel panel-default panel-lista" key={i}>
                    <div className="panel-heading">
                        <div className="media">
                            <div className="media-left">
                                <div className={status.classe}>
                                    <span className={status.icone}></span>
                                </div>
                            </div>
                            <div className="media-body body-lista-panel">
                                <p className="media-heading">{this.props.GetTipoAtividade(elem.ati_tipo)}</p>
                                <span>{status.status}</span>
                            </div>
                            <div className="acao pull-right">
                                {this.getStatusButtonAtividades(elem,i)}
                            </div>
                        </div>
                    </div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-md-10">
                                <p>Prazo: {  moment(elem.ati_data_fim).format("DD/MM/YYYY")}</p>
                                <p>{elem.ati_titulo}</p>
                            </div>
                            <div className="col-md-2">

                                <div className="concluidos">
                                    <Link to={`${this.props.menu.desafios.desempenho}/${elem.ati_id}`}>
                                        {/* <div className="numeros">50</div> */}
                                        <div className="txt">Resposta <br/> dos alunos</div>
                                    </Link>
                                </div>

                            </div>
                        </div>
                    </div>
                    {elem.status ===5 || elem.status ===6 ? <div className="panel-footer"><Link to={`${url}/${elem.ati_id}`}> Adicionar questão para este desafio</Link></div>:""}
                  
                </div>;
            });

        }else{
          return  <FlashRetornoNulo/>;
        }    
  }

    render(){      
        return (
                <div>
                {this.state.load ? this.renderListAtividades() : <FlashCarregando/>}
                </div>
               );
    }
}

function mapStateToProps(state){
    
        return {
          session             : state.auth.session,
          checkSelect     : state.scopoReducer.checkSelect,
          atividadesProfessor : state.atividadesReducer.allAtividadesLista,
          menu                : state.configReducer.menu
        }
    }
    
    export default connect(mapStateToProps,{SetExcluirAtividades,GetAtividadesLista,GetTipoAtividade,SetAnularAtividades,SetError})(Desafios_Professor_Lista)
    
    


// WEBPACK FOOTER //
// ./src/components/professor/desafios/desafios_professor_lista.js